
export default {
  timeFormate(originVal) {
    if(originVal == '' || originVal == undefined){
      return "-"
    }
    const dt = new Date(originVal)
    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')

    const hh = (dt.getHours() + '').padStart(2, '0')
    const mm = (dt.getMinutes() + '').padStart(2, '0')
    const ss = (dt.getSeconds() + '').padStart(2, '0')

    return `${y}/${m}/${d} ${hh}:${mm}:${ss}`
  },
  yearMonthDateFormate(originVal) {
    const dt = new Date(originVal)
    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')
    return `${y}/${m}/${d}`
  },

  // 将分钟数量转换为小时和分钟字符串
  toHourMinute(minutes) {
    var time;
    if (minutes == undefined || minutes == 0) {
      time = '00:00'
    } else {
      time = this.addZero(parseInt(minutes / 60)) + ":" + this.addZero(minutes % 60)
    }
    return time
  },
  addZero(hms) {
    return ("0" + hms).slice(-2);
  },
  toFixed(data){
    if(data == '' ||data == undefined){
      return " - "
    }
    return parseFloat(data).toFixed(2) 
  },
  timeLenghtTwo(endTime, type) {
    var secondTime = parseInt(endTime)
    var min = 0
    var h = 0
    var result = ''
    if (secondTime > 60) {
      min = parseInt(secondTime / 60)
      secondTime = parseInt(secondTime % 60)
      if (min > 60) {
        h = parseInt(min / 60)
        min = parseInt(min % 60)
      }
    }
    if (type) {
      result = this.addZero(h) + ":" + this.addZero(min) + ":" + this.addZero(secondTime)
    } else {
      if (h < 1) {
        result = min.toString() + "分钟"
      } else {
        result = h.toString() + "小时" + min.toString() + "分钟"
      }
    }
    return result
  }
}